import { authLogin, authLoginFacebook } from 'logic/auth';

export const Login = {
  template: `
    <div class="login">
      <div class="main-content theme-mid pt-4">
        <div class="container align-items-center justify-content-center pb-5">
          <div class="row">
            <div class="col-lg-6 mx-auto px-2 px-sm-0">
              <header class="text-center pt-2 pb-4"
                ng-hide="$ctrl.facebookAccessToken">
                <divider-zig-zag>
                  <h1 class="h2 text-white">
                    Login into Voome
                  </h1>
                </divider-zig-zag>
              </header>
              <header class="text-center pt-2 pb-2"
                ng-show="$ctrl.facebookAccessToken">
                <divider-zig-zag>
                  <h1 class="h2 text-white">
                    Link account with Facebook
                  </h1>
                </divider-zig-zag>
                <div class="text-white">
                  <p>To sign in with Facebook we need to link it to your Voome account.</p>
                  <p>Don't worry - you only need to do this once and we won't post anything without your permission.</p>
                </div>
              </header>
              <section class="p-3 theme-light">
                <div class="container px-3 px-lg-4 pt-4 pb-3 bg-white">
                  <div scroll-top-on-change="$ctrl.message">
                    <alert type="{{ $ctrl.error ? 'danger' : 'success' }}"
                      ng-if="$ctrl.message">
                      {{ $ctrl.message }}
                    </alert>
                  </div>
                  <div class="text-center mb-3 mb-md-5"
                    ng-hide="$ctrl.isWelcomeMessage">
                    <div class="fb-login-button"
                      data-max-rows="1"
                      data-size="large"
                      data-button-type="continue_with"
                      data-show-faces="false"
                      data-auto-logout-link="false"
                      data-use-continue-as="true"
                      onlogin="checkLoginState()">
                    </div>
                    <div class="mt-3">
                      <divider-hr>
                        <span class="text-gray-500"
                          ng-hide="$ctrl.facebookAccessToken">
                          OR
                        </span>
                        <span class="text-gray-500"
                          ng-show="$ctrl.facebookAccessToken">
                          LINK VOOME WITH FACEBOOK
                        </span>
                      </divider-hr>
                    </div>
                  </div>
                  <form-login
                    on-submit="$ctrl.authLogin(data, $ctrl.facebookAccessToken)"
                    is-loading="$ctrl.isLoading">
                  </form-login>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>`,

  controller($ngRedux, $timeout) {
    'ngInject';

    window.checkLoginState = () => $ngRedux.dispatch(authLoginFacebook());

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);
      },

      $onDestroy() {
        this.unsubscribe();
      },

      mapState({ auth }) {
        const { facebookAccessToken, error, isLoading, message } = auth;
        const isWelcomeMessage = /Welcome/.test(message);

        return {
          facebookAccessToken,
          error,
          isLoading,
          isWelcomeMessage,
          message,
        };
      },

      mapDispatch() {
        return { authLogin };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Login.js